// extracted by mini-css-extract-plugin
module.exports = {"currency":"currency_currency__CBBmV"};